import React, { useEffect } from "react";
import { useTable, usePagination } from "react-table";

const DataTable = ({ columns, data, enablePagination = true }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    state,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    usePagination
  );

  useEffect(() => {
    setPageSize(10);
  }, [setPageSize]);

  const visibleRows = enablePagination ? page : rows;
  const totalRows = data.length;
  const startEntry =
    totalRows === 0 ? 0 : state.pageIndex * state.pageSize + 1;
  const endEntry =
    totalRows === 0
      ? 0
      : Math.min((state.pageIndex + 1) * state.pageSize, totalRows);

  return (
    <>
      <table
        className="table table-bordered align-middle mb-0 data-table-core"
        {...getTableProps()}
      >
        <thead className="table-light">
          {headerGroups.map((hg) => (
            <tr {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col) => (
                <th
                  {...col.getHeaderProps()}
                  className="sticky-top bg-light data-table-sticky-head"
                >
                  {col.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()} className="data-table-body">
          {visibleRows.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center text-muted py-4 data-table-empty"
              >
                No records found
              </td>
            </tr>
          ) : (
            visibleRows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="data-table-row">
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} className="data-table-cell">
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>

      {enablePagination && (
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mt-3 data-table-pagination">
          <div className="small text-muted">
            Showing {startEntry} to {endEntry} of {totalRows} entries
          </div>

          <div className="d-flex gap-2 justify-content-md-end">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DataTable;
